import * as core from '../../../../../../../core'

import { query } from './change-impact-log.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impact.log',
    description:
      'Table view of the change impact log, including linked personas (Change360)',
    name: 'Change Impact Log',
    query,
    variables: [
      {
        id: 'workstream',
        name: 'Workstream',
        type: {
          enumId: 'enum::!change_impact_functional_area',
          isMultiselect: false,
        },
      },
      {
        id: 'phase',
        name: 'Phase/Epic',
        type: {
          enumId: 'enum::!change_impact_phase',
          isMultiselect: false,
        },
      },
      {
        id: 'sprint',
        name: 'Sprint',
        type: {
          enumId: 'enum::!change_impact_sprint',
          isMultiselect: false,
        },
      },
      {
        id: 'topic',
        name: 'Topic',
        type: core.common.value.types.Intrinsic.Text,
      },
      {
        id: 'department',
        name: 'Department',
        type: {
          enumId: 'enum::!change_impact_department',
          isMultiselect: true,
        },
      },
      {
        id: 'degreeOfChange',
        name: 'Degree of Change',
        type: {
          enumId: 'enum::!change_impact_rank',
          isMultiselect: false,
        },
      },
      {
        id: 'areaOfConcern',
        name: 'Area of Concern',
        type: core.common.value.types.Intrinsic.Boolean,
      },
      {
        id: 'keyBenefit',
        name: 'Key Benefit',
        type: core.common.value.types.Intrinsic.Boolean,
      },
      {
        id: 'type',
        name: 'Type',
        type: {
          enumId: 'enum::!change_impact_type',
          isMultiselect: true,
        },
      },
      {
        id: 'anticipatedResponseOfChange',
        name: 'Anticipated Response of Change',
        type: {
          enumId: 'enum::!change_impact_anticipated_response',
          isMultiselect: false,
        },
      },
      {
        id: 'validationStatus',
        name: 'Validation Status',
        type: {
          enumId: 'enum::!change_impact_validation_status',
          isMultiselect: false,
        },
      },
    ],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
